import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import { AbsenceManager, type AbsenceManagerHandle } from "./AbsenceManager";
import {
  type AbsenceManagerDataProps,
  absenceManagerDataSchema,
} from "./AbsenceManager.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "absence-manager": {
      props: AbsenceManagerDataProps;
      handle: AbsenceManagerHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-absence-manager": HTMLElement & AbsenceManagerHandle;
  }
}

export function RWCAbsenceManager({
  ref,
}: AbsenceManagerDataProps & { ref?: Ref<AbsenceManagerHandle> }) {
  const host = useIslandHost();

  return (
    <AbsenceManager
      ref={ref}
      onSaved={() =>
        host?.dispatchEvent(new CustomEvent("absences:save", { bubbles: true }))
      }
    />
  );
}

componentManager.register(
  rwc("absence-manager", {
    component: RWCAbsenceManager,
    dataSchema: absenceManagerDataSchema,
  }),
);
